import { getDatalists } from 'features/datalist/datalist.slice';
import React from 'react';
import { useSelector } from 'react-redux';
import Creatable from 'react-select/creatable';

import Select from 'react-select';

export type MultiSelectProps = {
    values: any;
    update: any;
    options: any;
    colors: any;
    placeholder: string;
    name: string;
    labelKey?: string;
    valueKey?: string;
    isMulti?: boolean;
    creatable?: boolean;
};

export const MultiSelect: React.FC<MultiSelectProps> = ({ values, update, options, colors, labelKey = "email", valueKey = "id", creatable = false, placeholder, name, isMulti = true }) => {
    const handleChange = (selectedOptions: any) => {
        update(selectedOptions);
    };

    const mappedOptions = options.map((option: any) => ({
        value: option[valueKey],
        label: option[labelKey]
    }));


    const customStyles = {
        option: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: 'white',
            color: 'black',
            '&:hover': {
                opacity: 0.8
            }
        }),
        multiValue: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: colors[state.data.value % colors.length],
            color: 'white'
        }),
        multiValueLabel: (provided: any, state: any) => ({
            ...provided,
            color: 'white'
        }),
        container: (provided: any, state: any) => {
            return {
                ...provided,
                zIndex: state.isFocused ? 1 : 0
            }
        }
    };
    return (
        creatable ? 
        <Creatable
            isMulti={isMulti}
            name={name}
            options={mappedOptions}
            value={values}
            onChange={handleChange}
            placeholder={placeholder}
            styles={customStyles}
            noOptionsMessage={() => 'Aucun résultat'}
            formatCreateLabel={(input) => `Créer "${input}"`}
            loadingMessage={() => 'Chargement des résultats...'}
        />
        :
            <Select
                isMulti={isMulti}
                name={name}
                isClearable={true}
                options={mappedOptions}
                value={values}
                className="react-custom-select"
                onChange={handleChange}
                placeholder={placeholder}
                styles={customStyles}
                noOptionsMessage={() => 'Aucun résultat'}
                loadingMessage={() => 'Chargement des résultats...'}
            />
    );
};
